import { createFileRoute, redirect } from "@tanstack/react-router";

// The hub lives at /font-generator (exact-match the primary keyword). Permanent
// redirect from the earlier /fonts path.
export const Route = createFileRoute("/fonts/")({
  beforeLoad: () => {
    throw redirect({ to: "/font-generator", statusCode: 301 });
  },
});
